import { render, staticRenderFns } from "./AuditGys.vue?vue&type=template&id=5b47fede&"
import script from "./AuditGys.vue?vue&type=script&lang=js&"
export * from "./AuditGys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports